import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { Breadcrumbs, Link, Typography } from '@mui/material';
import { doc, getDoc } from 'firebase/firestore';
import { useTranslation } from 'react-i18next';

import { mediasRef } from '../../../api/firebase/firestore/media';
import { gray } from '../../../constants/Colors';
import {
  mypageHeader,
  mypageHeaderTitle,
  mypageWrapper
} from '../../../constants/Location';
import { screenType } from '../../../constants/enum';
import MypageMediaDetail from '../../uiParts/MypageMediaDetail';
import Sidebar from '../../uiParts/Sidebar';

const styles = {
  breadcrumbs: {
    '.MuiBreadcrumbs-separator': {
      margin: '0 8px 2px 8px'
    },
    display: 'flex',
    fontSize: '12px',
    margin: '12px 0 0 24px'
  },
  breadcrumbsText: {
    color: gray,
    fontSize: '12px'
  },
  mypageHeader,
  mypageHeaderTitle,
  mypageWrapper
};

const ClientMypageMediaDetail: React.FC = () => {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    void (async () => {
      const mediaRef = doc(mediasRef, id);
      const mediaDoc = await getDoc(mediaRef);
      const mediaData = mediaDoc.data();

      document.title =
        mediaData && typeof mediaData.name === 'string'
          ? `${mediaData.name} | ${t('title.client.clientMediage')}`
          : t('title.client.clientMediage');
    })();
  }, []);

  const breadcrumbs = [
    <Link
      underline="hover"
      key="1"
      href="/main/client/mypage/media"
      sx={styles.breadcrumbsText}
    >
      {t('mypage.mediaList')}
    </Link>,
    <Typography key="4" sx={styles.breadcrumbsText}>
      {t('media.mediaDetail')}
    </Typography>
  ];

  return (
    <>
      <Typography component="div" sx={styles.mypageWrapper}>
        <Sidebar screenType={screenType.client} />
        <Typography
          component="div"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            minWidth: 0,
            position: 'static',
            width: '100%'
          }}
        >
          <Typography sx={styles.mypageHeader} component="div">
            <Typography sx={styles.mypageHeaderTitle}>
              {t('media.mediaDetail')}
            </Typography>
          </Typography>
          <Breadcrumbs
            separator=">"
            aria-label="breadcrumb"
            sx={styles.breadcrumbs}
          >
            {breadcrumbs}
          </Breadcrumbs>
          <MypageMediaDetail mediaId={id} screen={screenType.client} />
        </Typography>
      </Typography>
    </>
  );
};

export default ClientMypageMediaDetail;
